import { IconProps, iconColor } from './IconProps'

export function NoticeIcon(props: IconProps): JSX.Element {
  const { color = 'textInteractive', ...restProps } = props
  const size = props.size || 14

  return (
    <svg
      {...props}
      width={size}
      height={size}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM10 5.4502C10.5523 5.4502 11 5.89791 11 6.4502V10.4502C11 11.0025 10.5523 11.4502 10 11.4502C9.44771 11.4502 9 11.0025 9 10.4502V6.4502C9 5.89791 9.44771 5.4502 10 5.4502ZM8.9502 13.4502C8.9502 12.8979 9.39791 12.4502 9.9502 12.4502H10.0498C10.6021 12.4502 11.0498 12.8979 11.0498 13.4502V13.5502C11.0498 13.8161 10.9439 14.071 10.7555 14.2587C10.5671 14.4463 10.3118 14.5512 10.0459 14.5502L9.94627 14.5498C9.39552 14.5476 8.9502 14.1006 8.9502 13.5498V13.4502Z'
        fill={iconColor({ color, ...restProps })}
      />
    </svg>
  )
}
